import { undoInputRule } from 'prosemirror-inputrules';
import { splitListItem, sinkListItem, liftListItem } from 'prosemirror-schema-list';
import { MenuItem } from './plugins/MenuItem';
import { undo, redo, bold, em, link, indent } from './plugins/menuItems';
import { Schema } from 'prosemirror-model';
import { EditorState, Command } from 'prosemirror-state';

// tslint:disable-next-line: strict-type-predicates
const mac = typeof window.navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;

export default function buildKeymap(schema) {
  const keys = {};

  function bindItem(key, item) {
    if (item.spec && (schema.nodes[item.spec.name] || schema.marks[item.spec.name])) {
      keys[key] = item.onKeypress.bind(item);
    }
  }

  function bindAction(key, cmd) {
    keys[key] = cmd;
  }

  bindAction('Mod-z', undo.command);

  bindAction('Shift-Mod-z', redo.command);

  bindAction('Backspace', undoInputRule);

  if (!mac) bindAction('Mod-y', redo.command);

  bindAction('Enter', splitListItem(schema.nodes.list_item));

  bindAction('Mod-]', sinkListItem(schema.nodes.list_item));

  bindAction('Mod-[', liftListItem(schema.nodes.list_item));

  bindAction('Tab', indent);

  bindItem('Mod-b', bold);

  bindItem('Mod-B', bold);

  bindItem('Mod-i', em);

  bindItem('Mod-I', em);

  bindItem('Mod-k', link);

  bindAction('Escape', (state, dispatch) =>
    dispatch(state.tr.setMeta('escape', true))
  );

  return keys;
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/buildKeymap.js